import { render, staticRenderFns } from "./VoteList.vue?vue&type=template&id=fdc309d8&scoped=true&"
import script from "./VoteList.vue?vue&type=script&lang=js&"
export * from "./VoteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc309d8",
  null
  
)

export default component.exports